<template>
  <div
    class="loader"
    :class="{
      'is-relative': relative,
      'is-inline': inline,
      'has-minheight': minHeight
    }"
  >
    <img src="@/assets/images/loader.gif" />
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    relative: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
$loader-size: 100px !default;
$loader-min-height: 25vh !default;

.loader {
  position: relative;

  img {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: $loader-size;
    height: $loader-size;
    transform: translate(-50%, -50%);
  }

  &.is-relative {
    img {
      position: relative;
      top: 0;
      left: 0;
      margin: auto;
      transform: none;
    }
  }

  &.is-inline {
    img {
      position: relative;
      top: 0;
      left: 0;
      margin: auto;
      width: 1em;
      height: 1em;
      transform: none;
    }
  }

  &.has-minheight {
    min-height: $loader-min-height;
  }
}
</style>
